import React from 'react';

import { CardActions, Chip } from 'components';
import { withStyles, createStyleSheet } from 'material-ui/styles';

type Item = {
  id?: string,
  label: string,
};

type Props = {
  classes: Object,
  items?: Array<Item>,
};

const styleSheet = createStyleSheet('ChipActions', {
  item: {
    margin: '8px 8px 0 0',
  },
});

const ChipActions = ({
  component: Component,
  classes,
  items,
  ...rest
}: Props) => {
  console.log('items', items);
  if (!items || !items.length) {
    return null;
  }

  return (
    <CardActions {...rest}>
      {items.map(item =>
        <Chip key={item.id} label={item.label} className={classes.item} />
      )}
    </CardActions>
  );
};

ChipActions.defaultProps = {
  items: [],
};

export default withStyles(styleSheet)(ChipActions);



// WEBPACK FOOTER //
// ./src/common/components/ChipActions.js